module.exports = __webpack_public_path__ + "img/topindicator2.9a1c57af.png";